import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../action/ActionArgs'
import type { FilterQuery } from '../repository/types'
import GraphQLJSON from 'graphql-type-json'
import type { IBaseEntity } from '../base/BaseEntity'

export interface IStateTransition<T extends IBaseEntity> {
  moveToState<TArgs = any>(args: StateTransitionArgs<T, TArgs>): Promise<T>
}

export interface Transition<T extends IBaseEntity> {
  state: string
  executorServiceId: ExecutorConstructor<T> | symbol
}

type ExecutorConstructor<T extends IBaseEntity> = new (...args: any[]) => ITransitionService<T, any>

export type TransitionRollArgs<T, TArgs = any> = StateTransitionArgs<T, TArgs> & { entity: T }
export interface ITransitionService<T extends IBaseEntity, TArgs = any> {
  commit(args: TransitionRollArgs<T, TArgs>): Promise<void>
  rollback(args: TransitionRollArgs<T, TArgs>): Promise<void>
}

@InputType()
export class StateTransitionArgs<T, TArgs = any> extends ActionArgs {
  @Field(() => GraphQLJSON)
  filter?: FilterQuery<T>

  @Field(() => String, { nullable: true })
  targetState?: string

  @Field(() => GraphQLJSON)
  args?: TArgs
}
